let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eNFJX")).then(() => parcelRequire('aEKbH'));